/* eslint-disable jsx-a11y/no-noninteractive-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
import React, {
  useRef,
  useEffect,
  useCallback,
  useMemo,
  useState,
} from 'react';

import { Button } from 'components/Atoms';
import { useStore } from 'hooks';
import usePlacesAutocomplete, {
  getGeocode,
  getLatLng,
} from 'use-places-autocomplete';
import { handleClickOutside } from 'utils/handleClickOutside';

import { InputGMPlaces } from './InputGMPlaces';
import * as T from './interfaces';

export const Container = ({
  id,
  onChange,
  forwardPlaces,
  ...rest
}: T.IInputGMPlaces) => {
  const {
    ready,
    value,
    suggestions: { status, data },
    setValue,
    clearSuggestions,
  } = usePlacesAutocomplete({
    requestOptions: {
      /* Define search scope here */
      // bounds: '',
      componentRestrictions: {
        country: 'br',
      },
      //  location: [],
      //  offset: 0,
      //  origin: [],
      //  radius: 0,
      //  sessionToken: '',
      types: ['establishment'],
    },
    debounce: 300,
  });

  const {
    toggleSearchedLocation,
    toggleListPlacesWithPosition,
    changePlacesSuggestion,
  } = useStore();

  const wrapperRef = useRef(document.createElement('div'));

  const [searchIsActive, setSearchIsActive] = useState(false);

  // const onClickOutside = useCallback(() => {
  //   !!clearSuggestions && handleClickOutside(wrapperRef, clearSuggestions);
  // }, [wrapperRef, clearSuggestions]);

  // useEffect(() => {
  //  // onClickOutside();
  //   // eslint-disable-next-line react-hooks/exhaustive-deps
  // }, []);

  const handleInputClick = () => {
    setSearchIsActive(true);
  };

  const onCloseIconClick = () => {
    changePlacesSuggestion([]);
    setSearchIsActive(false);
    setValue('', false);
  };

  const handleChange = useCallback(
    value => {
      setValue(value);
      !!onChange && onChange(value);
    },
    [setValue, onChange],
  );

  const handleSelect = useCallback(
    description => {
      setValue(description, false);
      clearSuggestions();
      setSearchIsActive(false);

      getGeocode({ address: description })
        .then(results => getLatLng(results[0]))
        .then(({ lat, lng }) => {
          toggleSearchedLocation([lat, lng]);
          toggleListPlacesWithPosition(lat, lng);
        })
        .catch(error => {
          console.log('😱 Error: ', error);
        });
    },
    [getGeocode, clearSuggestions, setValue, getLatLng],
  );

  useEffect(() => {
    const arrayPlaces = data.map(suggestion => {
      const {
        place_id,
        structured_formatting: { main_text, secondary_text },
        description,
      } = suggestion;

      return (
        <Button
          key={place_id}
          id={`suggestionPlace${place_id}`}
          type="button"
          variant="ghost"
          title={`Selecione para escolher ${main_text}`}
          onClick={() => handleSelect(description)}
          noHeritage
        >
          <div>
            <strong>{main_text}</strong>
            <small>{secondary_text}</small>
          </div>
        </Button>
      );
    });
    forwardPlaces(arrayPlaces);
  }, [data]);

  return (
    <InputGMPlaces
      {...rest}
      onInputClick={handleInputClick}
      onCloseIconClick={onCloseIconClick}
      searchIsActive={searchIsActive}
      wrapperRef={wrapperRef}
      id={`placesAutocomplete@${id}`}
      value={value}
      onChange={handleChange}
      disabled={!ready}
      showMedia={data.length > 0}
    />
  );
};
